export const getRootDomain = (hostName) => {
  const hostParts = hostName.split(".");

  if (hostParts.length <= 2) {
    return hostName;
  }

  const prefixParts = hostParts.slice(-3);
  if (["co", "com"].indexOf(prefixParts[1]) > -1) {
    return prefixParts.join(".");
  }

  return hostParts.slice(-2).join(".");
};
